module.exports = __webpack_public_path__ + "static/media/confirmacao-icon.ab533dac.svg";